var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "modal-decline-reason",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "modal-decline-reason",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("h3", [_vm._v("Why did you withdraw the request?")]),
              _vm._v(" "),
              _vm._l(_vm.withdrawalOptions, function (option) {
                return _c(
                  "button",
                  {
                    key: option.id,
                    staticClass: "btn btn-block btn-dark",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: {
                      click: function ($event) {
                        return _vm.handleWithdrawRequestReasonCallback(
                          option.id
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(option.label) +
                        "\n                "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }